import type { ReactNode } from 'react';
import type React from 'react';
import { createContext, useContext, useState } from 'react';

interface DefinitionModalContextType {
  isOpen: boolean;
  juriID: string;
  renID: string;
  refID: string;
  pageID: string;
  openModal: (
    juriID: string,
    renID: string,
    refID: string,
    pageID?: string
  ) => void;
  closeModal: () => void;
}

const DefinitionModalContext = createContext<
  DefinitionModalContextType | undefined
>(undefined);

export const useDefinitionModal = () => {
  const context = useContext(DefinitionModalContext);
  if (!context) {
    throw new Error(
      'useDefinitionModal must be used within a DefinitionModalProvider'
    );
  }
  return context;
};

interface DefinitionModalProviderProps {
  children: ReactNode;
}

export const DefinitionModalProvider: React.FC<
  DefinitionModalProviderProps
> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [juriID, setJuriID] = useState('');
  const [renID, setRenID] = useState('');
  const [refID, setRefID] = useState('');
  const [pageID, setPageID] = useState('');

  const openModal = (
    newJuriID: string,
    newRenID: string,
    newRefID: string,
    newPageID: string = 'demo'
  ) => {
    setJuriID(newJuriID);
    setRenID(newRenID);
    setRefID(newRefID);
    setPageID(newPageID);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <DefinitionModalContext.Provider
      value={{
        isOpen,
        juriID,
        renID,
        refID,
        pageID,
        openModal,
        closeModal,
      }}
    >
      {children}
    </DefinitionModalContext.Provider>
  );
};
